// Static, build-time feature toggles. See .github/copilot-instructions.md
// "Feature toggles" section for usage conventions before adding new entries.
// NOTE: Utilities module guest/third-party access moved to the remote
// "ThirdPartyAccessToUtilitiesModule" flag via FeatureFlagProvider/FeatureGate
// (see src/routing/routes/utilitiesRoutes.tsx) instead of a static toggle here.
export const featureToggle = {
  CopyWorkRequest: true,
  CopyWorkRequestProcess: false,
  CopySampleFromExistingMidas: true,
  CreateNewSample: true,
};
